import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';

interface iButtonProps extends ButtonProps {
  href?: string;
  target?: string;
}

const BlgButton = ({ ...props }: iButtonProps) => {
  const defaultStyle: ButtonProps = {
    borderRadius: 'full',
    px: 6,
    textDecor: 'none !important',
  };

  return <Button {...defaultStyle} {...props} />;
};

export default BlgButton;
